import Configs from "../../vendorConfigs/Configs";
import GameModel from "../../../core/src/model/GameModel";
import { IRequestBuilder } from "../../../core/src/server/requests/RequestBuilder";


export default class FunLoginRequest implements IRequestBuilder {
    get method() {
        return "POST";
    }
  
    get path() {
        if (GameModel.urlParams?.currency) {
            return Configs.game.clientConfig.gameServerApi + "/demormlogin";
        } else {
            return Configs.game.clientConfig.gameServerApi + "/funmoneylogin";
        }
    }
  
    get requestData() {
        return {
            g: Configs.vendorServer.gameId,
            channel: GameModel.urlParams.channel || "web",
            currency: GameModel.currency || "EUR",
            partnerid: GameModel.partnerid,
            jurisdiction: GameModel.urlParams.jurisdiction,
            clientversion: GameModel.gameVersion,
        };
    }
}